import { Navigate } from "react-router-dom";
import Login from "../pages/Login";
import Home from "../pages/Home";
import Cache from "../pages/Cache";
import Pdf from "../pages/Pdf";
import Url from "../pages/Url";
import Questions from "../pages/Questions";
import DeepLink from "../pages/DeepLink";
import HistoryLogs from "AdminSection/pages/HistoryLogs";
import ErrorLogs from "AdminSection/pages/ErrorLogs";
import ApiMonitor from "AdminSection/pages/ApiMonitor";
export const ADMIN_ROUTES = [
  {
    path: "/admin",
    element: <Login />,
    isNavBarDisplay: false,
  },
  {
    path: "/admin/pdf",
    element: (
      <Home>
        <Pdf />
      </Home>
    ),
    isNavBarDisplay: true,
  },
  {
    path: "/admin/url",
    element: (
      <Home>
        <Url />
      </Home>
    ),
    isNavBarDisplay: true,
  },
  {
    path: "/admin/cache",
    element: (
      <Home>
        <Cache />
      </Home>
    ),
    isNavBarDisplay: true,
  },
  {
    path: "/admin/questions",
    element: (
      <Home>
        <Questions />
      </Home>
    ),
    isNavBarDisplay: true,
  },
  {
    path: "/admin/deeplinks",
    element: (
      <Home>
        <DeepLink />
      </Home>
    ),
    isNavBarDisplay: true,
  },
  {
    path: "/admin/analytics",
    element: (
      <Home>
        <HistoryLogs />
      </Home>
    ),
    isNavBarDisplay: true,
  },
  {
    path: "/admin/error",
    element: (
      <Home>
        <ErrorLogs />
      </Home>
    ),
    isNavBarDisplay: true,
  },
  {
    path: "/admin/api_monitor",
    element: (
      <Home>
        <ApiMonitor />
      </Home>
    ),
    isNavBarDisplay: true,
  },
  {
    path: "/admin/*",
    element: <Navigate to="/" />,
    isNavBarDisplay: false,
  },
  {
    path: "*",
    element: <div>Not Found Page</div>,
    isNavBarDisplay: false,
  },
];
